import React, {Component, Fragment, createRef} from 'react';
import {
    Navbar, 
    // Nav, 
    // NavLink
} from 'react-bootstrap';
import './Navbar.scss';
import {Routes, BrowserRouter as Router, Route, useLocation, useParams, useSearchParams, useNavigate, Link} from "react-router-dom";

import Init from '../../../Init/Init';

import NavigationContext from '../../../Context/NavigationContext';

// import UtilityFunction from '../../../Util/Util';

import TopMenu from '../TopMenu/TopMenu';
// import CustomMarquee from '../../Utilities/Marquee/Marquee';

import { connect } from 'react-redux';
import { getAuthenticatedUser } from '../../../Redux/Auth/auth-action';
import shoppingCartActions from '../../../Redux/Shopping/shopping-action';
import shippingActions from '../../../Redux/Shipping/shipping-action';
// import marqueeActions from '../../../Redux/Marquee/marquee-action';
import addonActions from '../../../Redux/Addon/addon-action';
import receiverBankAccountActions from '../../../Redux/ReceiverBankAccount/receiver-bank-account-action';
import shoppingCartAPI from '../../../Data/ShoppingCart';
import CustomToast from '../../Utilities/Toast/Toast';
import PrimaryButton from '../../Utilities/PrimaryButton/PrimaryButton';
import SecondaryButton from '../../Utilities/SecondaryButton/SecondaryButton';

const { loadCart, loadDesignAttachment, clearDesignAttachment } = shoppingCartActions;
const { getAddons, getStraws } = addonActions;
const { getCourier } = shippingActions;
const { getAccounts } = receiverBankAccountActions;
// const { getMarquee } = marqueeActions;

const mapStateToProps = (state) => {
    return {
        identity: state.auth.identity
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getIdentity: () => dispatch(getAuthenticatedUser()),
        loadCart: () => dispatch(loadCart()),
        loadAddons: () => dispatch(getAddons()),
        loadStraws: () => dispatch(getStraws()),
        loadCourier: () => dispatch(getCourier()),
        loadRecipientAccount: () => dispatch(getAccounts()),
        loadDesignAttachment: async () => dispatch(await loadDesignAttachment()),
        // getMarquee: () => dispatch(getMarquee()),
        clearAttachment: async () => dispatch(await clearDesignAttachment())
    }
};

const withParameters = (Component) => {
    function ComponentWithRouter(props) {
        const params = useParams();
        const [queryParams] = useSearchParams();
        const location = useLocation();

        const navigate = useNavigate(); 

        return (
            <NavigationContext.Provider value={{
                navigate: (targetPath, options = {
                    replace: true,
                    state: {}
                }) => {
                    navigate(targetPath, options);
                },
                params,
                queryParams,
                location
            }}>
                <Component 
                    {...props} 
                />
            </NavigationContext.Provider>
        )
    }

    return ComponentWithRouter
}
class NavigationBar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentPath: window.location.pathname,
            group: {
                isLoaded: false,
                data: []
            },
            marquee: {
                isLoaded: false,
                data: []
            },
            searchText: createRef(),
            mobileScreen: window.innerWidth <= 768,
            repeatOrderToast: {
                show: 0,
                status: 1,
                title: "Pesan Lagi?"
            }
        };
    }

    componentDidMount() {
        this.props.getIdentity();
        this.props.loadCart();
        this.props.loadAddons();
        this.props.loadStraws();
        this.props.loadCourier();
        // this.props.loadRecipientAccount();
        this.props.loadDesignAttachment();
        // this.props.getMarquee();

        const existingHistory = shoppingCartAPI.controller.checkOrderHistory();
        if( Object.values(existingHistory).length > 0 ) {
            this.setState( (state) => {
                state.repeatOrderToast.show = 1;
                return state;
            } );
        }

        let thisComponent = this;

        window.addEventListener('resize', () => {
            const screenWidth = window.innerWidth;
            const mobileScreen = screenWidth <= 768;

            if(thisComponent.state.mobileScreen !== mobileScreen) {
                thisComponent.setState({
                    ...thisComponent.state,
                    mobileScreen
                });
            }

        });   
    }

    componentDidUpdate() {
        // window.scrollTo({
        //     top: 0,
        //     behavior: 'smooth'
        // });
    }

    componentWillUnmount() {
        this.setState = (state,callback)=>{
            return;
        };

        window.removeEventListener('resize', () => {});
    }

    searchProduct(event) {
        // Enter Key Code = 13
        const searchKeyword = this.state.searchText.current.value;

        if(event.keyCode === 13 && searchKeyword !== '') {
            let searchPath = `/category?s=${searchKeyword}`;
            
            window.location.href = searchPath;
        }
    }

    chooseCategory(path) {
        let state = this.state;

        state.currentPath = path;

        this.setState(state);
    }

    toggleSubgroup(id, show) {
        const dropdown = document.getElementById(`navbar-hover-${id}`);

        if(dropdown !== null) {
            show ? dropdown.classList.add('show') : dropdown.classList.remove('show');
        }
    }

    repeatOrder() {
        const isLogin = this.props.identity.hasOwnProperty('customer_code');
        if( !Init.config.requireLogin || (Init.config.requireLogin && isLogin) ) {
            // Copy from lastOrderHistory to ShoppingCart and notify Redux
            shoppingCartAPI.controller.repeatOrder(isLogin ? this.props.identity.customer_code : "guest");
            shoppingCartAPI.controller.clearOrderHistory();
    
            // Navigate to cart
            window.location.href = "/cart";
        } else {
            window.location.href = "/login";
        }
    }

    noRepeatOrder() {
        // Clear lastOrderHistory
        shoppingCartAPI.controller.clearOrderHistory();
        this.props.clearAttachment();

        // Close Toast
        this.setState( (state) => {
            state.repeatOrderToast.show = 0;
            return state;
        } );
    }

    render() {
        const { config, FontAwesomeIcon } = Init;
        let logoPath = config.imageLogo;
        
        const Topmenu = withParameters(TopMenu);

        return (
            <Fragment>
                <Router>
                    <CustomToast
                        toastClass="repeat-order-toast"
                        title="Re-order?"
                        show={this.state.repeatOrderToast.show}
                        status={this.state.repeatOrderToast.status}
                        customClass="repeat-order-toast-content"
                    >
                        <div className="reorder-label">
                            Anda melakukan transaksi dengan YoboyCup sebelumnya. Mau pesan pesanan yang sama lagi?
                        </div>
                        <div className="reorder-button-container">
                            <PrimaryButton size="sm" customClass="btn-repeat-order" onClick={() => this.repeatOrder()}>
                                Ya, Pesan Lagi! <FontAwesomeIcon icon={['fas', 'arrow-right']} />
                            </PrimaryButton>

                            <SecondaryButton size="sm" customClass="btn-close-toast" onClick={() => this.noRepeatOrder()}>
                                Tidak, Pesan yang lain!
                            </SecondaryButton>
                        </div>
                    </CustomToast>
                    <Navbar className={`${ this.props.hide ? 'd-none' : '' }`} expand={false}>
                        <div className="navbar-first-row">
                            {/* 
                                <div className={`
                                    search-bar 
                                    ${ this.state.mobileScreen ? 'd-none' : '' }
                                `}>
                                    <FontAwesomeIcon icon={['fas', 'search']} className='search-icon' />
                                    <input type="text" ref={this.state.searchText} onKeyDown={(event) => this.searchProduct(event)} className="search-box" placeholder='Search...'/>
                                </div>
                            */}

                            <Navbar.Brand>
                                <Link to="/">
                                    <img className="nav-logo" src={logoPath} alt="Logo" />
                                </Link>
                            </Navbar.Brand>
                            
                            <Topmenu mobileScreen={this.state.mobileScreen} menu={this.state.group.data} />
                        </div>

                        {/* <div className="navbar-third-row">
                            <CustomMarquee />
                        </div> */}
                    </Navbar>
                    {/* Render the first matched path */}
                    <Routes>
                        {
                            this.props.navList.map((route, i) => {
                                    // const ComponentWithParameters = this.state.group.isLoaded ? withParameters(route.component) : LoadingPage;  
                                    const ComponentWithParameters = withParameters(route.component);  
                                    
                                    return (
                                        <Route
                                            key={i}
                                            path={route.path}
                                            element={<ComponentWithParameters />}
                                        >
                                            {
                                                route.hasOwnProperty('route') && route.route.length > 0 ? (
                                                    route.route.map( (childRoute, index) => {
                                                        // const ChildComponent = this.state.group.isLoaded ? withParameters(childRoute.component) : LoadingPage; 
                                                        const ChildComponent = withParameters(childRoute.component); 

                                                        return (
                                                            <Route
                                                                key={index}
                                                                path={childRoute.path}
                                                                element={<ChildComponent />}
                                                            />
                                                        )
                                                    } )
                                                ) : ''
                                            }
                                        </Route>
                                    )
                                } 
                            )
                        }
                    </Routes>
                </Router>
            </Fragment>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(NavigationBar);